import { useEffect, useState } from 'react';

/**
 * Reactively tracks whether the site is in dark mode.
 * Watches mutations on <html> classList (Tailwind class-based dark mode).
 */
export function useIsDark() {
    const [isDark, setIsDark] = useState(() =>
        typeof document !== 'undefined' && document.documentElement.classList.contains('dark')
    );

    useEffect(() => {
        const update = () => setIsDark(document.documentElement.classList.contains('dark'));
        const obs = new MutationObserver(update);
        obs.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
        return () => obs.disconnect();
    }, []);

    return isDark;
}
